import { useEffect, useMemo, useState } from "react";
import CustomTableWithFilter from "../../ReUsableComponent/CustomTableWithFilter";
import CustomPagination from "../../ReUsableComponent/Pagination";
import {
  FileCenterTableHeader,
  storeNamePopupTableHeader,
} from "../TableHeaders";
import Loader from "../../ReUsableComponent/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  ToastErrorService,
  ToastSuccessService,
} from "../../ReUsableComponent/ToastNotification/ToastService";
import {
  GetFiledownloadById,
  GetRetryFileProcessById,
  GetStoreContractList,
  GetUploadedFileList,
} from "./file-center.service";
import { fileCenterActions } from "../../store/reducers/fileCenterReducer";
import moment from "moment";
import CustomFilterSearchDropdown from "../../ReUsableComponent/CustomFilterSearchDropdown";
import dropDownIcon from "../../assets/svg/dropDownIcon.svg";
import CloseIcon from "../../assets/svg/closeIconofmodal.svg";
import CalendarIcon from "../../assets/svg/calendar_2_fill.svg";
import { GetBrandNameList } from "../Promotion/promotion.service";
import CustomFilterDropDown from "../../ReUsableComponent/CustomFilterDropdown";
import CustomModal from "../../ReUsableComponent/CustomModal";
import CustomDateRangePicker from "../../ReUsableComponent/CustomDaterangePicker";
import dayjs from "dayjs";
import { GetSalesYear } from "../SalesOverview/SalesOverview.service";

const uploadedFileModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#F2F2F2",
  boxShadow: 24,
  p: "40px 32px",
  borderRadius: 6,
  border: "1px solid #3333330D",
};

// Add this helper function at the top of your FileCenter component
const getValidDate = (dateValue) => {
  if (!dateValue) return undefined;
  try {
    const date = new Date(dateValue);
    return isNaN(date.getTime()) ? undefined : date;
  } catch (error) {
    return undefined;
  }
};

const FileCenter = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const USER_ID = useSelector((state) => state.userAuthentication.userId);
  const USER_TOKEN = useSelector((state) => state.userAuthentication.userToken);
  const selectedFileCenterData = useSelector((state) => state.fileCenter);
  const selectedPage = useSelector((state) => state.fileCenter.selectedPage);
  const selectedMonthYear = useSelector(
    (state) => state.fileCenter.selectedMonthYear,
  );
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(
    selectedFileCenterData.selectedBrand,
  );
  const [selectedStore, setSelectedStore] = useState(
    selectedFileCenterData.selectedStore,
  );
  const [selectedStatus, setSelectedStatus] = useState(
    selectedFileCenterData.selectedStatus,
  );
  const [uploadedFilesRawData, setUploadedFilesRawData] = useState([]);
  const [anchorElForBrand, setAnchorElForBrand] = useState(null);
  const [anchorElForStore, setAnchorElForStore] = useState(null);
  const [anchorElForStatus, setAnchorElForStatus] = useState(null);
  const [anchorElForDate, setAnchorElForDate] = useState(null);
  const openBrandFilter = Boolean(anchorElForBrand);
  const openStoreFilter = Boolean(anchorElForStore);
  const openStatusFilter = Boolean(anchorElForStatus);
  const openDateFilter = Boolean(anchorElForDate);
  const [brandList, setBrandList] = useState([]);
  const [brandRawList, setBrandRawList] = useState(selectedFileCenterData.brandRawList);
  const [storeFilterList, setStoreFilterList] = useState(
    selectedFileCenterData.storeFilterList,
  );
  const [storeRawList, setStoreRawList] = useState(
    selectedFileCenterData.storeRawList,
  );
  const [openStoreNameModal, setOpenStoreNameModal] = useState(false);
  const [storePopupList, setStorePopupList] = useState([]);
  const [monthYearList, setMonthYearList] = useState([]);
  const today = new Date();
  today.setDate(1);
  today.setHours(-1);
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth());
  const [selectedRange, setSelectedRange] = useState([]);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [disabledDateRange, setDisabledDateRange] = useState(true);
  const [startDate, setStartDate] = useState(
    selectedFileCenterData.startDate
      ? getValidDate(selectedFileCenterData.startDate)
      : undefined,
  );
  const [endDate, setEndDate] = useState(
    selectedFileCenterData.endDate
      ? getValidDate(selectedFileCenterData.endDate)
      : undefined,
  );
  const startDateDisplay = useSelector(
    (state) => state.fileCenter.startDateDisplay,
  );
  const endDateDisplay = useSelector(
    (state) => state.fileCenter.endDateDisplay,
  );
  const [dropSearchValue, setdropSearchValue] = useState({
    brand: "",
    store: "",
  });
  const [statusList, setStatusList] = useState([
    { label: "Success", value: "Success" },
    { label: "Failed", value: "Failed" },
    { label: "In Progress", value: "In progress" },
    { label: "Yet to start", value: "Yet to start" },
  ]);

  useEffect(() => {
    getAllBrand();
    getMonthYearList();
  }, []);

  useEffect(() => {
    if (
      selectedBrand?.value &&
      (selectedMonthYear.label !== "Custom" ||
        (selectedMonthYear.label === "Custom" &&
          startDateDisplay &&
          endDateDisplay))
    ) {
      console.log(1);
      getUploadedFileList(1);
      dispatch(fileCenterActions.setSelectedPage(1));
    }
  }, [
    selectedBrand,
    selectedStatus,
    selectedStore,
    selectedMonthYear,
    selectedRange,
    startDateDisplay,
    endDateDisplay,
  ]);

  const updatedUploadedFiles = useMemo(() => {
    if (!storeRawList?.length) return uploadedFilesRawData;

    const storeMap = new Map();
    const emailMap = new Map();

    storeRawList.forEach((store) => {
      storeMap.set(store.store, store);

      const emails = [
        store.store_email,
        ...(store.communication_mail_ids || []),
      ]
        .filter(Boolean)
        .map((email) => email.toLowerCase());

      emails.forEach((email) => {
        if (!emailMap.has(email)) {
          emailMap.set(email, new Set());
        }
        emailMap.get(email).add(store.store_name);
      });
    });

    // Process each uploaded file
    return uploadedFilesRawData.map((file) => {
      const store = storeMap.get(file.store_id);

      // Case 1: Direct store match by store_id (highest priority)
      if (store) {
        return {
          ...file,
          store_name: store.store_name || store.store || file.store_name,
          matchedStores: [], // No need for matched stores when we have direct match
        };
      }

      // Case 2 & 3: Match by email (only when no direct store_id match)
      const emailKey = (file.actionEmail || "").toLowerCase();

      if (emailKey && emailMap.has(emailKey)) {
        const matchedStoreNames = [...emailMap.get(emailKey)];

        return {
          ...file,
          store_name:
            matchedStoreNames.length === 1
              ? matchedStoreNames[0] // Case 2: Single store match
              : `${matchedStoreNames[0]} + ${matchedStoreNames.length - 1}`, // Case 3: Multiple matches - keep original, but provide array
          matchedStores:
            matchedStoreNames.length > 1
              ? matchedStoreNames // Case 3: Array of all matching store names
              : [], // No array needed for single match
        };
      }

      // Case 4: No match found - keep original
      return {
        ...file,
        matchedStores: [],
      };
    });
  }, [storeRawList, uploadedFilesRawData]);

  const getUploadedFileList = (selectedPagePara) => {
    console.log("called final list")
    setLoading(true);
    let brandParams = "";
    let storeParams = "";
    let dateParams = "";
    let statusParams = "";
    if( selectedBrand.value) {
      brandParams = getBrandParams(); 
    }
    if (selectedStore.value) {
      storeParams = getStoreParams();
    }
    if (selectedStatus.value) {
      statusParams = getStatusParams();
    }
    if (selectedMonthYear.label) {
      if (selectedMonthYear.label === "Custom") {
        if (startDateDisplay && endDateDisplay) {
          dateParams = getDateParams();
        }
      } else {
        dateParams = getDateParams();
      }
    }
    let param = `?page=${selectedPagePara}&limit=${20}${brandParams}${statusParams}${storeParams}${dateParams}`;
    GetUploadedFileList(param, USER_TOKEN)
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setUploadedFileList(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          history.push("/");
        }
        ToastErrorService(
          error.response?.data?.message || "An error occurred.",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAllBrand = () => {
    console.log('fetching brands');
    setLoading(true);
    let param = `?user_id=${USER_ID}`;
    GetBrandNameList(param, USER_TOKEN)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let brands = [];
          let rawBrands = [];
          response.data.data.forEach((element) => {
            let brandObject = {
              label: element.brand_name,
              value: element._id,
            };
            let rawBrandObject = {
              brand: element._id,
              brand_name: element.brand_name,
              brand_email: element.email_id,
            }
            brands.push(brandObject);
            rawBrands.push(rawBrandObject);
          });
          if (
            !selectedBrand.value ||
            !brands.find((elem) => elem.value === selectedBrand.value)
          ) {
            getAllStore(brands[0]?.value);
            dispatch(
              fileCenterActions.setSelectedBrand({
                label: brands[0]?.label,
                value: brands[0]?.value,
              }),
            );
            setSelectedBrand({
              label: brands[0]?.label,
              value: brands[0]?.value,
            });
          }
          if (selectedBrand.value) {
            getAllStore(selectedBrand?.value);
          }
          setBrandList(brands);
          setBrandRawList(rawBrands);
          dispatch(fileCenterActions.setBrandRawList(rawBrands));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          history.push("/");
        }
        ToastErrorService(error.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAllStore = (brandId) => {
    // setLoading(true);
    let param = `?user_id=${USER_ID}&brand_id=${brandId}`;
    GetStoreContractList(param, USER_TOKEN)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let stores = [];
          let storesRaw = [];
          response.data.data.forEach((element) => {
            let storeObject = {
              label: element.store_name ?? element.store,
              value: element.store,
            };
            let storeRawObject = {
              store: element.store,
              store_name: element.store_name ?? element.store,
              store_email: element.store_email ?? "-",
              communication_mail_ids: element.communication_mail_ids ?? [],
            };
            stores.push(storeObject);
            storesRaw.push(storeRawObject);
          });
          if (
            selectedStore?.value &&
            !stores.find((elem) => elem.value === selectedStore?.value)
          ) {
            setSelectedStore({ label: "", value: "" });
            dispatch(
              fileCenterActions.setSelectedStore({ label: "", value: "" }),
            );
          }
          setStoreFilterList(stores);
          setStoreRawList(storesRaw);
          dispatch(fileCenterActions.setStoreFilterList(stores));
          dispatch(fileCenterActions.setStoreRawList(storesRaw));
        }
      })
      .catch((error) => {
        ToastErrorService(error?.response?.data?.message);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const setUploadedFileList = (result) => {
    let tableData = [];

    result?.data?.map((item) => {
      let row = {
        id: item?._id,
        brand_name: item?.brand_name ?? selectedBrand?.label,
        store_name: item?.store_name ?? item?.store_id ?? "-",
        store_id: item?.store_id ?? "-",
        report_type: item?.report_type,
        file_name: item?.file_attachment_name ?? "-",
        service_type: item?.service_type,
        created_at: item?.created_at ? convertDate(item?.created_at) : "-",
        status: getStatus(item),
        sender_email: item?.sender_email ?? "-",
        comment: item?.comment ?? "-",
        actionEmail: setEmailForMaster(item),
      };
      tableData.push(row);
    });
    setUploadedFilesRawData(tableData);
    setTotalCount(result?.total);
  };

  const setEmailForMaster = (item) => {
    if (item?.report_type === "Stock" && item?.receiver_email) {
      return item?.receiver_email;
    } else if (item?.report_type === "Sales" && item?.sender_email) {
      return item.sender_email;
    } else {
      return null;
    }
  };

  const convertDate = (openingDate) => {
    let date = new Date(openingDate);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let dateString = `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
    return moment(dateString).format("DD MMM YYYY");
  };

  const convertDateDisplay = (openingDate) => {
    if (!openingDate) return "";

    const isWeekFormat = (str) =>
      /^Week: \d+ \(\d{4}-\d{2}-\d{2} to \d{4}-\d{2}-\d{2}\)$/.test(str);
    if (isWeekFormat(openingDate)) {
      return openingDate;
    }

    try {
      let date = new Date(openingDate);
      if (isNaN(date.getTime())) return "";
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let dateString = `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
      return moment(dateString).format("DD MMM YYYY");
    } catch (error) {
      return "";
    }
  };

  const getStatus = (item) => {
    if (item?.file_execution_status === "Yet to start") {
      return "Yet to start";
    }
    if (item?.file_execution_status === "In progress") {
      return "In Progress";
    }
    if (item?.file_execution_status === "Completed") {
      if (item?.is_data_processed && !item?.is_processed_failed) {
        return "Success";
      } else return "Failed";
    }
  };

  const getMonthYearList = () => {
    GetSalesYear(USER_TOKEN)
      .then((response) => {
        let salesYear = [];
        let dateItems = [];

        response.data.data.forEach((element) => {
          try {
            const date = moment(element, "MMMM YYYY");
            if (date.isValid()) {
              dateItems.push({
                label: element,
                value: element,
                sortDate: date.toDate(),
              });
            } else {
              dateItems.push({
                label: element,
                value: element,
                sortDate: new Date(0),
              });
            }
          } catch (e) {
            dateItems.push({
              label: element,
              value: element,
              sortDate: new Date(0),
            });
          }
        });

        dateItems.sort((a, b) => b.sortDate.getTime() - a.sortDate.getTime());

        salesYear = [
          ...dateItems.map(({ label, value }) => ({ label, value })),
          { label: "Custom", value: "" },
        ];

        setMonthYearList(salesYear);
        setDisabledDateRange(true);

        // Check if current selection is "Custom" but no dates are selected
        const isCustomWithNoDates =
          selectedMonthYear.label === "Custom" &&
          !selectedFileCenterData.startDate &&
          !selectedFileCenterData.endDate &&
          !startDateDisplay &&
          !endDateDisplay;

        // If Custom with no dates, reset to first month
        if (isCustomWithNoDates) {
          const latestMonth = dateItems.length > 0 ? dateItems[0] : null;
          if (latestMonth) {
            dispatch(
              fileCenterActions.setSelectedMonthYear({
                label: latestMonth.label,
                value: latestMonth.value,
              }),
            );
            setDisabledDateRange(true);
          }
          return;
        }

        // Only set default if no selection exists or if selection is invalid
        if (!selectedMonthYear.label || selectedMonthYear.label === "") {
          const latestMonth = dateItems.length > 0 ? dateItems[0] : null;
          if (latestMonth) {
            dispatch(
              fileCenterActions.setSelectedMonthYear({
                label: latestMonth.label,
                value: latestMonth.value,
              }),
            );
          } else if (salesYear.length > 0) {
            dispatch(
              fileCenterActions.setSelectedMonthYear({
                label: salesYear[0]?.label,
                value: salesYear[0]?.value,
              }),
            );
          }
          dispatch(fileCenterActions.setStartDateDisplay(null));
          dispatch(fileCenterActions.setEndDateDisplay(null));
          dispatch(fileCenterActions.setStartDate(null));
          dispatch(fileCenterActions.setEndDate(null));
        }

        if (selectedMonthYear.label === "Custom") {
          setDisabledDateRange(false);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          history.push("/");
        }
        ToastErrorService(error.response.data.message);
      })
      .finally(() => {});
  };

  const getBrandParams = () => {
    
    let brand_id = selectedBrand.value;
    const selectedRawBrand = brandRawList.find(
      (elem) => elem.brand === brand_id,
    );
    return `&brand_id=${brand_id}&brand_email=${selectedRawBrand?.brand_email}`;
  }

  const getStoreParams = () => {
    let store_id = selectedStore.value;
    const selectedRawStore = storeRawList.find(
      (elem) => elem.store === selectedStore.value,
    );
    let store_emails = [
      selectedRawStore.store_email,
      ...selectedRawStore.communication_mail_ids,
    ];
    const emailParams = store_emails
      .filter((email) => email)
      .map((email) => `store_emails=${email}`)
      .join("&");
    return `&store_id=${store_id}&${emailParams}`;
  };

  const getStatusParams = () => {
    if (selectedStatus.value) {
      return `&status=${selectedStatus.value}`;
    }
    return "";
  };

  const getDateParams = () => {
    let startDate = "";
    let endDate = "";

    if (selectedMonthYear.label !== "Custom") {
      try {
        const monthYear = selectedMonthYear.label;
        const date = moment(monthYear, "MMMM YYYY");

        if (date.isValid()) {
          const start = date.clone().startOf("month");
          startDate = start.format("YYYY-MM-DD");

          const end = date.clone().endOf("month");
          endDate = end.format("YYYY-MM-DD");
        }
      } catch (error) {
        console.error("Error parsing date:", error);
      }
    } else {
      // For Custom selection, use the selected range from date picker
      if (startDateDisplay && endDateDisplay) {
        try {
          const start = new Date(startDateDisplay);
          const end = new Date(endDateDisplay);

          if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
            startDate = moment(start).format("YYYY-MM-DD");
            endDate = moment(end).format("YYYY-MM-DD");
          }
        } catch (error) {
          console.error("Error parsing custom dates:", error);
        }
      }
    }

    // Only return if we have valid dates
    if (startDate && endDate) {
      return `&startDate=${startDate}&endDate=${endDate}`;
    }

    return "";
  };

  //   const onGridReady = (params) => {
  //         params.api.setFilterModel(tableFilterValue);
  //         gridRef.current = params.api;
  //         gridRef.current.sizeColumnsToFit();
  //     };

  //     const onFilterChanged = (event) => {
  //             dispatch(promotionActions.setFilterModel({ type: event.api.getFilterModel() }));
  //         };

  //         const onClickReset = () => {
  //             const gridApi = gridRef.current;
  //             gridApi.setFilterModel(null); // Clears all the filters
  //             gridApi.onFilterChanged();    // Apply the changes
  //         }

  // Pagination Func

  const handlePageChange = (pageValue) => {
    dispatch(fileCenterActions.setSelectedPage(pageValue));
      console.log(2);
    getUploadedFileList(pageValue);
  };

  const handleBrandClick = (event) => {
    setAnchorElForBrand(event.currentTarget);
  };
  const handleStoreClick = (event) => {
    setAnchorElForStore(event.currentTarget);
  };
  const handleStatusClick = (event) => {
    setAnchorElForStatus(event.currentTarget);
  };
  const handleDateClick = (event) => {
    setAnchorElForDate(event.currentTarget);
  };

  const handleBrandClose = () => {
    setAnchorElForBrand(null);
  };
  const handleStoreClose = () => {
    setAnchorElForStore(null);
  };

  const handleStatusClose = () => {
    setAnchorElForStatus(null);
  };

  const handleDateClose = () => {
    setAnchorElForDate(null);
  };

  const onSelectBrand = (event) => {
    const selectedValue = event.target.value;
    const selected = brandList.find((brand) => brand.value === selectedValue);

    if (selected) {
      onClickClear("store");
      getAllStore(selected.value);
      setSelectedBrand({ label: selected.label, value: selected.value });

      // Update Redux
      dispatch(
        fileCenterActions.setSelectedBrand({
          label: selected.label,
          value: selected.value,
        }),
      );

      // Close dropdown
      setAnchorElForBrand(null);

      // Clear search input
      setdropSearchValue((prev) => ({ ...prev, brand: "" }));

      // Fetch promotions
      //   getUploadedFileList(1);
    }
  };

  const onSelectStore = (event) => {
    const selectedValue = event.target.value;
    const selected = storeFilterList.find(
      (store) => store.value === selectedValue,
    );

    if (selected) {
      setSelectedStore({ label: selected.label, value: selected.value });

      // Update Redux
      dispatch(
        fileCenterActions.setSelectedStore({
          label: selected.label,
          value: selected.value,
        }),
      );

      // Close dropdown
      setAnchorElForStore(null);

      // Clear search input
      setdropSearchValue((prev) => ({ ...prev, store: "" }));

      // Fetch promotions
      //   getUploadedFileList(1);
    }
  };

  const onSelectStatus = (event) => {
    const selectedValue = event.target.value;
    const selected = statusList.find(
      (status) => status.value === selectedValue,
    );

    if (selected) {
      setSelectedStatus({ label: selected.label, value: selected.value });

      // Update Redux
      dispatch(
        fileCenterActions.setSelectedStatus({
          label: selected.label,
          value: selected.value,
        }),
      );

      // Close dropdown
      setAnchorElForStatus(null);
    }
  };

  const handleSearchChange = (event, name) => {
    if (name === "brand") {
      const inputValue = event.target.value;
      setdropSearchValue((prev) => ({ ...prev, brand: inputValue }));
    }
    if (name === "store") {
      const inputValue = event.target.value;
      setdropSearchValue((prev) => ({ ...prev, store: inputValue }));
    }
  };

  const onClickClear = (filter) => {
    if (filter === "store") {
      setSelectedStore({ label: "", value: "" });
      dispatch(fileCenterActions.setSelectedStore({ label: "", value: "" }));
      handleStoreClose();
    }
    if (filter === "status") {
      setSelectedStatus({ label: "", value: "" });
      dispatch(
        fileCenterActions.setSelectedStatus({
          label: "",
          value: "",
        }),
      );
      handleStatusClose();
    }
  };

  const onClickDownloadFile = (id) => {
    // setLoading(true);
    let param = `?id=${id}`;
    GetFiledownloadById(param, USER_TOKEN).then((response) => {
      if (response.data.statusCode === 200) {
        window.open(response.data.presignedFileUrl, "_blank");
        ToastSuccessService("File downloaded successfully");
      } else if (response.data.statusCode === 400) {
        ToastErrorService(response.data.message);
      }
    });
  };

  const onClickViewPopup = (data) => {
    setOpenStoreNameModal(true);
    let storeListTemp = [];
    data.matchedStores.map((elem, index) => {
      const storeObj = { sno: `${index + 1}.`, store_name: elem };
      storeListTemp.push(storeObj);
    });
    setStorePopupList(storeListTemp);
  };

  const onClickRetryFile = (id) => {
    let param = `?file_id=${id}`;
    GetRetryFileProcessById(param, USER_TOKEN).then((response) => {
      if (response.data.statusCode === 200) {
        ToastSuccessService(response.data.message);
      } else if (response.data.statusCode === 400) {
        ToastErrorService(response.data.message);
      }
    });
  };

  const handleDateRangeSelect = (date) => {
    if (!date) return;

    // Validate the date
    const validDate = new Date(date);
    if (isNaN(validDate.getTime())) return;

    if (!startDate || (startDate && endDate)) {
      // Start new selection
      setStartDate(validDate);
      setEndDate(undefined);
      // setSelectedRange([validDate]);
    } else if (startDate && !endDate && validDate >= startDate) {
      // Complete the range
      let endDay = dayjs(validDate).endOf("day");
      const endDateObj = endDay.toDate();
      setEndDate(endDateObj);
      setSelectedRange([startDate, endDateObj]);
      setCalendarOpen(false);

      // Update Redux only with valid dates
      if (
        startDate instanceof Date &&
        !isNaN(startDate.getTime()) &&
        endDateObj instanceof Date &&
        !isNaN(endDateObj.getTime())
      ) {
        dispatch(
          fileCenterActions.setStartDateDisplay(startDate.toISOString()),
        );
        dispatch(fileCenterActions.setEndDateDisplay(endDateObj.toISOString()));
        dispatch(fileCenterActions.setStartDate(startDate.toISOString()));
        dispatch(fileCenterActions.setEndDate(endDateObj.toISOString()));
      }
    } else if (startDate && !endDate && validDate < startDate) {
      // Reset start date
      setStartDate(validDate);
      setSelectedRange([validDate]);
    }
  };

  const convertDateStringToObj = (dateString) => {
    const dateInIST = moment.tz(dateString, "Asia/Kolkata");
    const finalFormattedDate = new Date(dateInIST.format());
    return finalFormattedDate;
  };

  const openCalendar = () => {
    setCalendarOpen((prev) => !prev);
  };

  const onSelectDateYear = (event) => {
    if (event.target.value !== "") {
      dispatch(
        fileCenterActions.setSelectedMonthYear({
          label: event.target.value,
          value: event.target.value,
        }),
      );
      dispatch(fileCenterActions.setStartDateDisplay(null));
      dispatch(fileCenterActions.setEndDateDisplay(null));
      dispatch(fileCenterActions.setStartDate(null));
      dispatch(fileCenterActions.setEndDate(null));
      setDisabledDateRange(true);
    } else {
      setDisabledDateRange(false);
    }
    if (event.target.value === "") {
      dispatch(
        fileCenterActions.setSelectedMonthYear({
          label: "Custom",
          value: event.target.value,
        }),
      );
    } else {
      dispatch(
        fileCenterActions.setSelectedMonthYear({
          label: event.target.value,
          value: event.target.value,
        }),
      );
    }
    setAnchorElForDate(null);
  };

  return (
    <>
      <div className="d-flex">
        {/* brand filter */}
        <div className="position-relative min-w-150">
          <button
            className="d-flex statusFilter cursorPointer align-items-center justify-content-between me-3"
            onClick={handleBrandClick}
          >
            <p
              className="text-truncate"
              title={selectedBrand?.label || "Select Brand"}
            >
              {selectedBrand?.label || "Select Brand"}
            </p>
            <img
              className={`${openBrandFilter ? "transform180 pe-2" : "ps-2"}`}
              src={dropDownIcon}
              alt=""
            />
          </button>
          <CustomFilterSearchDropdown
            data={brandList}
            handleClose={handleBrandClose}
            open={openBrandFilter}
            anchorEl={anchorElForBrand}
            onChange={onSelectBrand}
            selectedValue={selectedBrand?.value}
            category={"brand"}
            dropSearchValue={dropSearchValue.brand}
            handleSearchChange={(e) => handleSearchChange(e, "brand")}
            setdropSearchValue={setdropSearchValue}
          />
        </div>
        {/** Store Filter */}
        <div className="position-relative min-w-150">
          <button
            className="d-flex statusFilter cursorPointer align-items-center justify-content-between me-3"
            onClick={handleStoreClick}
          >
            <p
              className="text-truncate"
              title={selectedStore?.label || "Select Store"}
            >
              {selectedStore?.label || "Select Store"}
            </p>
            <img
              className={`${openStoreFilter ? "transform180 pe-2" : "ps-2"}`}
              src={dropDownIcon}
              alt=""
            />
          </button>
          <CustomFilterSearchDropdown
            data={storeFilterList}
            handleClose={handleStoreClose}
            open={openStoreFilter}
            anchorEl={anchorElForStore}
            onChange={onSelectStore}
            selectedValue={selectedStore?.value}
            category={"Store"}
            onClickClear={() => onClickClear("store")}
            dropSearchValue={dropSearchValue.store}
            handleSearchChange={(e) => handleSearchChange(e, "store")}
            setdropSearchValue={setdropSearchValue}
          />
        </div>

        {/** Status Filter */}
        <div className="position-relative min-w-150">
          <button
            className="d-flex statusFilter cursorPointer align-items-center justify-content-between me-3"
            onClick={handleStatusClick}
          >
            <p
              className="text-truncate"
              title={selectedStatus?.label || "Select Status"}
            >
              {selectedStatus?.label || "Select Status"}
            </p>
            <img
              className={`${openStatusFilter ? "transform180 pe-2" : "ps-2"}`}
              src={dropDownIcon}
              alt=""
            />
          </button>
          <CustomFilterDropDown
            data={statusList}
            handleClose={handleStatusClose}
            selectedValue={selectedStatus?.value}
            open={openStatusFilter}
            anchorEl={anchorElForStatus}
            onChange={onSelectStatus}
            category={"Category"}
            onClickClear={() => onClickClear("status")}
          />
        </div>

        {/** Date range */}
        <div className="d-flex align-items-center ms-auto">
          <div className="position-relative min-w-150">
            <button
              className="d-flex statusFilter cursorPointer align-items-center justify-content-between me-3"
              onClick={handleDateClick}
            >
              <p className="text-truncate" title={selectedMonthYear.label}>
                {selectedMonthYear?.label || "Select Month"}
              </p>
              <img
                className={`${openDateFilter ? "transform180 pe-2" : "ps-2"}`}
                src={dropDownIcon}
                alt=""
              />
            </button>
            <CustomFilterDropDown
              data={monthYearList}
              handleClose={handleDateClose}
              open={openDateFilter}
              anchorEl={anchorElForDate}
              onChange={onSelectDateYear}
              selectedValue={selectedMonthYear?.value}
              category={"Category"}
            />
          </div>
          <div className="position-relative">
            <button
              className={`d-flex dateRangeFilter cursorPointer align-items-center ${disabledDateRange ? "justify-content-between" : ""}`}
              disabled={disabledDateRange}
              onClick={openCalendar}
            >
              <img src={CalendarIcon} alt="" />
              {startDateDisplay && endDateDisplay ? (
                <div>{`${convertDateDisplay(startDateDisplay)} - ${convertDateDisplay(endDateDisplay)}`}</div>
              ) : (
                <div className="text-center w-100">Select Range</div>
              )}
            </button>
            <div className="">
              <CustomDateRangePicker
                restrictFutureDates={true}
                startDate={startDate}
                endDate={endDate}
                calendarOpen={calendarOpen}
                selectedRange={selectedRange}
                handleSelect={handleDateRangeSelect}
                closeOnOutSide={() => setCalendarOpen(false)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="paddingTop24">
        <div className="tableContainer">
          <CustomTableWithFilter
            column={FileCenterTableHeader}
            totalRow={() => {}}
            // onFilterChanged={onFilterChanged}
            tableRowData={updatedUploadedFiles}
            // onGridReady={onGridReady}
            // handleActiveToggle={changePromotionsStatus}
            // onClickEdit={onClickPromotionsEdit}
            // onClickView={onClickPromotionsView}
            // onClickDeletePromo={onClickDeletePromo}
            onClickDownloadFile={onClickDownloadFile}
            onClickViewPopup={onClickViewPopup}
            onClickRetryFile={onClickRetryFile}
            customeHeightClass={"tableCustomeHeightClass"}
          />
        </div>
        <div className="paddingTop16 d-flex justify-content-end customPagination">
          <CustomPagination
            onClick={handlePageChange}
            activePage={selectedPage}
            pageSize={20}
            currentPage={selectedPage}
            totalItems={totalCount}
          />
        </div>
      </div>
      {loading && <Loader />}
      <CustomModal
        classes="customeProgressModal"
        open={openStoreNameModal}
        style={uploadedFileModalStyle}
        handleClose={null}
        content={
          <div>
            <div className="d-flex align-items-center">
              <div className="montSerratFont fontSize18 textColorBlack position-relative d-flex w-100">
                <div className="pb-3">Stores ({storePopupList.length})</div>
                <button
                  className="uploadFileModalCloseIcon cursorPointer"
                  onClick={() => {
                    setOpenStoreNameModal(false);
                    setStorePopupList([]);
                  }}
                >
                  <img src={CloseIcon} alt="" />
                </button>
              </div>
            </div>
            <div className="tableContainer reports">
              <CustomTableWithFilter
                totalRow={() => {}}
                isContentLeftRightFixed={false}
                height={450}
                column={storeNamePopupTableHeader}
                tableRowData={storePopupList}
                // onClickDownloadReport={onClickDownloadReport}
                // onClickView={onClickView}
                // onFilterChanged={onFilterChanged}
                // onGridReady={onGridReady}
                // filterModel={tableFilterValue}
                customeHeightClass={"tableCustomeHeightClass"}
              />
            </div>
          </div>
        }
      />
    </>
  );
};

export default FileCenter;
